module.exports = __webpack_public_path__ + "img/logo.bcade899.png";